<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="row" >
      
      
     <div v-for="k in key_doc_latest" class="col-xl-3" :key="k.id">
      <card  header-classes="bg-gradient-default">
            <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h3 class="h3 text-white">
                <span v-if="k.type=='custom_document'">
                {{k.document_name}}
                </span>
                
                <span v-else>	{{k.doc_name}} </span>
                
                </h3>
              </div>
                <div class="col-auto">
				   <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-info">
						<i class="fa fa-file-alt"></i>
					</div>
                </div>
            </div>

            
            
        
			 <div style="text-align:center;margin-top:35px;">
        		 <base-button  @click="viewDocument(k.document_id)" type="success">View</base-button>
        	 </div>
          
      </card>
      </div>
      
      
      
      
       
    

       
      </div>
      <!-- End row-->

      <!--start new row-->
      
      <div class="row" style="margin-top:50px;">
     	<div class="col-xl-12">
     		 <div class="card">
        <div class="border-0 card-header">
            <h3 class="mb-0">All Key Documents</h3>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="key_documents">
            <el-table-column label="Document Name"
                             prop="doc_name"
                             min-width="240px"
                             >
            </el-table-column>
		     <el-table-column label="Uploaded"
                             prop="created_at_str"
                             min-width="220px"
                             >
            </el-table-column>
            
            <el-table-column label="Remarks"
                             prop="notes"
                             min-width="140px"
                             >
            </el-table-column>
            

            
             <el-table-column label="" >
                	<template slot-scope="scope">
                	  <base-button
                    @click="viewDocument(scope.row.document_id)"
                    class="remove btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-eye"></i>
                  </base-button>
          			</template>
        	</el-table-column>
        	
        	
          
        </el-table>
    </div>
		</div>
	 </div>
	 <!-- End row-->
	 
	 
	 <!--start new row-->
      
      <div class="row" style="margin-top:50px;">
     	<div class="col-xl-12">
     		 <div class="card">
        <div class="border-0 card-header">
            <h3 class="mb-0">Signed Documents</h3>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="signed_documents">
            <el-table-column label="Document Name"
                             prop="document_name"
                             min-width="240px"
                             >
            </el-table-column>
		     <el-table-column label="Created"
		     				 width="220px"
                             prop="created_at_str"
                            
                             >
            </el-table-column>
            
        	 
             <el-table-column label="View Signing Log" 
             		 width="250px"
             		>
                	<template slot-scope="scope">
                	  <base-button
                    @click="viewDocument_log(scope.row.id)"
                    class="remove btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-eye"></i>
                  </base-button>
          			</template>
        	</el-table-column>
            

            
             <el-table-column label="View Signed Document" 
             		width="250px"
             		>
                	<template slot-scope="scope">
                	  <base-button
                    @click="viewDocument_signed(scope.row.id)"
                    class="remove btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="text-white fa fa-eye"></i>
                  </base-button>
          			</template>
        	</el-table-column>
        	
        	
          
        </el-table>
    </div>
		</div>
	 </div>
	 <!-- End row-->

    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import { Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  		 [Table.name]: Table,
     	 [TableColumn.name]: TableColumn,
    },
    data() {
      return {
     	 key_documents:[],
     	 key_doc_latest:[],
     	 signed_documents: [],
	
      };
    },
    methods: {
      initBigChart(index) {

      },
       viewDocument(did){
      			this.$router.push( '/view-document/'+ did +"/0");
        },
        viewDocument_log(did){
      			this.$router.push( '/view-document/'+ did +"/2");
        },
        viewDocument_signed(did){
      			this.$router.push( '/view-document/'+ did +"/1");
        },
    },
    mounted() {
       swal.showLoading();
      
 		const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_key_docs/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.key_documents = response.data.key_documents;
      		 this.key_doc_latest = response.data.key_doc_latest;
      		 this.signed_documents = response.data.signed_docs;
   			 swal.close();
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














